import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex-col view-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "flex-col app-wrapper"
}
const _hoisted_3 = { class: "app-search" }
const _hoisted_4 = {
  key: 1,
  class: "flex-center"
}
const _hoisted_5 = { class: "bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_display = _resolveComponent("loader-display")!
  const _component_appointment_entry = _resolveComponent("appointment-entry")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_loader_display, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "page-header" }, [
          _createElementVNode("h3", { class: "page-title" }, "Select your booking")
        ], -1)),
        (_ctx.orderEntities.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "search",
                  id: "",
                  class: "si-input app-search-input",
                  placeholder: "Search by last name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchInput) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.searchInput]
                ]),
                _withDirectives(_createElementVNode("button", {
                  id: "clearBtn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchInput = ''))
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    "stroke-width": "2",
                    stroke: "currentColor",
                    fill: "none",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("line", {
                      x1: "18",
                      y1: "6",
                      x2: "6",
                      y2: "18"
                    }),
                    _createElementVNode("line", {
                      x1: "6",
                      y1: "6",
                      x2: "18",
                      y2: "18"
                    })
                  ], -1)
                ]), 512), [
                  [_vShow, _ctx.searchInput.length]
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orders, (order, i) => {
                return (_openBlock(), _createBlock(_component_appointment_entry, {
                  key: i,
                  order: order,
                  onOnClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleEntryClick($event)))
                }, null, 8, ["order"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.noBookingMsg), 1)
            ])),
        _createElementVNode("button", {
          class: "form-submit-btn",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getCheckinOrders(true)))
        }, _toDisplayString(_ctx.showingAll ? 'Refresh' : 'Show All'), 1)
      ]))
}